<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#85344c"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Cupons</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <router-link to="cupons/criar-cupom"  class="btn_1 medium pull-right mb-3">Criar cupom</router-link>
          </div>
        </div>

        <v-card>
          <v-card-title>Seus Cupons
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="cupons" :search="search">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.codigo }}</td>
              <td>{{ padronizaData(props.item.inicio) }}</td>
              <td>{{ padronizaData(props.item.fim) }}</td>
              <td>{{ props.item.limite_global }}</td>
              <td>{{ props.item.limite_usuario }}</td>
              <td>{{ props.item.porcentagem }}</td>
              <td class="text-xs-right">
                <router-link
                  :to="'/uniodonto/cupons/'+props.item.id"
                  class="btn_1 gray delete wishlist_close"
                >
                  <i class="fa fa-fw fa-edit"></i> Detalhes
                </router-link>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta, padronizaData } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";


export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      erroMensagem: "",
      mostraErro: false,
      headers: [
        { text: "id", value: "id" },
        { text: "Código", value: "codigo" },
        { text: "Inicio", value: "inicio" },
        { text: "Fim", value: "fim" },
        { text: "Limite global", value: "limite_global" },
        { text: "Limite usuário", value: "limite_usuario" },
        { text: "Porcentagem", value: "porcentagem" },
        { text: "Opções", value: "" }
      ],
      cupons: [],
      isLoading: false
    };
  },
  mounted() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
     self.isLoading = true;
     ajax("get", "/cupons")
       .then(response => {
        self.isLoading = false;
        self.cupons = response;
       })
       .catch(error => {
         self.isLoading = false;
         tratamento_requisicao(error, this);
       });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  }
};
</script>